// import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";

// import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";

const matomoInstance = createInstance({
    urlBase: "https://stats.stat.gov.pl",
    // srcUrl: "./js/matomo.js",
    siteId:
        process?.env?.REACT_APP_MATOMO_IDSITE && !isNaN(Number(process?.env?.REACT_APP_MATOMO_IDSITE))
            ? Number(process?.env?.REACT_APP_MATOMO_IDSITE)
            : 30,
    disabled: false, // true,
    heartBeat: {
        active: true,
        seconds: 10,
    },
    linkTracking: false,
    configurations: {
        disableCookies: true,
        setSecureCookie: true,
        setRequestMethod: "POST",
    },
});

ReactDOM.render(
    <React.Fragment>
        <ThemeProvider theme={theme}>
            <MatomoProvider value={matomoInstance}>
                <App />
            </MatomoProvider>
        </ThemeProvider>
    </React.Fragment>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
